import viewModel, { ViewModelContext } from "@lib/viewModel";
import React, { useMemo } from "react";
import type { ViewModel } from "@lib/viewModel";

export const ViewModelProvider = ({
  children,
  model = viewModel,
}: {
  children: React.ReactNode;
  model: ViewModel;
}) => {
  const contextValue = useMemo(
    () => ({
      viewModel: model,
      overrides: {},
    }),
    [model]
  );
  return <ViewModelContext.Provider value={contextValue}>{children}</ViewModelContext.Provider>;
};
